import { render, staticRenderFns } from "./ManuallySelectShop.vue?vue&type=template&id=8f3e8c7a"
import script from "./ManuallySelectShop.vue?vue&type=script&lang=js"
export * from "./ManuallySelectShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports